import AddSupplierDialog from '../../dialogs/add-supplier-dialog';
import layoutStorage from '../../storages/layout-storage';
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import suppliersStorage from "../../storages/suppliersStorage";

/* eslint-disable-next-line */
export interface SuppliersPageProps {}

export function SuppliersPage(props: SuppliersPageProps) {
  const { isAddSupplierModalOpen, toggleAddSupplierModalDialog } = layoutStorage;

  useEffect(() => {
    suppliersStorage.loadSuppliers();
  }, []);

  return (
    <div>
      <button onClick={toggleAddSupplierModalDialog}>Add supplier</button>
      <AddSupplierDialog
        opened={isAddSupplierModalOpen}
        onToggle={toggleAddSupplierModalDialog}
      />
    </div>
  );
}

export default observer(SuppliersPage);
